var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.74722V17.3272C10 19.4172 8.47 21.2772 6.39 21.4772C4 21.7072 2 19.8372 2 17.4972V5.13722C2 3.82722 2.94 2.63722 4.24 2.50722C5.74 2.35722 7 3.52722 7 4.99722V15.4972C7 16.0472 6.55 16.4972 6 16.4972C5.45 16.4972 5 16.0472 5 15.4972V6.74722C5 6.33722 4.66 5.99722 4.25 5.99722C3.84 5.99722 3.5 6.33722 3.5 6.74722V15.3572C3.5 16.6672 4.44 17.8572 5.74 17.9872C7.24 18.1372 8.5 16.9672 8.5 15.4972V5.16722C8.5 3.07722 6.97 1.21722 4.89 1.01722C2.51 0.787216 0.5 2.65722 0.5 4.99722V17.2672C0.5 20.1372 2.6 22.7072 5.46 22.9772C8.75 23.2772 11.5 20.7172 11.5 17.4972V6.74722C11.5 6.33722 11.16 5.99722 10.75 5.99722C10.34 5.99722 10 6.33722 10 6.74722Z",
    fill: "#001B53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclipIcon);
export default __webpack_public_path__ + "static/media/paperclip-icon.27c322ea423f30c1d81ff43c65f27018.svg";
export { ForwardRef as ReactComponent };